import Model, { attr } from '@ember-data/model';

export default class TeamConversationMemberModel extends Model {
  @attr('string') userId?: string | null;
  @attr('string') name?: string | null;
  @attr('date') lastReadAt?: Date | null;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'team-conversation-member': TeamConversationMemberModel;
  }
}
